import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {  FormGroup } from '@angular/forms';
import * as errorUtils from "src/app/modules/utility/global-utils";
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { LcaService } from 'src/app/services/lca.service';
import { ConfirmationService } from "primeng/api";

@Component({
  selector: 'app-lca-preparer',
  templateUrl: './lca-preparer.component.html',
  styleUrls: ['./lca-preparer.component.scss']
})
export class LcaPreparerComponent implements OnInit, OnChanges{

  @Input() lcaPreparer: FormGroup;
  @Input() editLcaDatalcaPreparer:any;
  isDuplicateLCA: boolean = false;
  destroy$ = new Subject();

  constructor(
    private lcaService: LcaService,
    private confirmationService: ConfirmationService,
    protected store: Store<any>) {}

    
  ngOnInit(): void {
    this.isDuplicateLCA = sessionStorage.getItem("isDuplicateLCA") === 'true';
  }

    
    
  ngOnChanges(changes: SimpleChanges){
  
    // console.log('beforeeditLcaDatalcaPreparer',changes);
    // if(changes.editLcaDatalcaPreparer.currentValue.company.companyId){
    //   console.log('editLcaDatalcaPreparer.............................',this.editLcaDatalcaPreparer);
    //  var firstName = this.editLcaDatalcaPreparer.firstName
    //  console.log('editLcaDatalcaPreparer.............................',this.editLcaDatalcaPreparer);


    //   this.lcaPreparer.patchValue({
    //     firstName: firstName,
    //     middleName: this.editLcaDatalcaPreparer.middleName,
    //     lastName: this.editLcaDatalcaPreparer.lastName,
    //     firmName: this.editLcaDatalcaPreparer.firmName,
    //     emailId:this.editLcaDatalcaPreparer.emailId.mailId,
    //     personType: "PREPARER",
    //   });

    //   console.log('editLcaDatalcaPreparer###########################');

    // }



  //       if(changes.editLcaDatalcaPreparer.currentValue){
  //         console.log('editLcaDatalcaPreparer');

  //   if(JSON.parse(localStorage.getItem('userEfileInfo'))){

  //     this.editLcaDatalcaPreparer = JSON.parse(localStorage.getItem('userEfileInfo')).lcaPreparer; 
  //     console.log('editLcaDatalcaPreparer',this.editLcaDatalcaPreparer);
  //     console.log('editLcaDatalcaPreparer.firstName',this.editLcaDatalcaPreparer.firstName);
  //     if(this.editLcaDatalcaPreparer.firstName){
  //       console.log('this.companycompanycompanycompanycompany', this.editLcaDatalcaPreparer.emailId.mailId );
     
  //       this.lcaPreparer.patchValue({
  //       firstName: this.editLcaDatalcaPreparer.firstName,
  //       middleName: this.editLcaDatalcaPreparer.middleName,
  //       lastName: this.editLcaDatalcaPreparer.lastName,
  //       firmName: this.editLcaDatalcaPreparer.firmName,
  //       emailId:this.editLcaDatalcaPreparer.emailId.mailId,
  //       personType:this.editLcaDatalcaPreparer.personType.code,
  //     });
  //     console.log('this.editLcaDatalcaPreparer.personType.code',  this.editLcaDatalcaPreparer.personType.code);

  //   }
  //     console.log('this.lcaPreparer',  this.lcaPreparer.value);

  //   }
  // }

  }
  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  clearData() {
    // Clear any previous confirmation
    this.confirmationService.close();

    this.confirmationService.confirm({
      header: "Clear Data",
      icon: "pi pi-exclamation-triangle",
      rejectLabel: "Cancel",
      acceptLabel: "Yes, Clear Data",
      acceptButtonStyleClass: "btn-accept-clear",
      rejectButtonStyleClass: "btn-cancel-clear",
      message: `<div class="mb-4"> This will clear all the data from this section. </div>
                <div class="mb-4"> Are you sure, you want to clear data? </div>`,
      accept: () => {
        this.lcaPreparer.reset();
        this.confirmationService.close();
      },
      reject: () => {
        // Clear the confirmation dialog instance after rejection
       this.confirmationService.close();
     },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
